import { render, staticRenderFns } from "./changePasswordPage.vue?vue&type=template&id=4fefb9e8&"
import script from "./changePasswordPage.vue?vue&type=script&lang=ts&"
export * from "./changePasswordPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports